import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { cartLinkStyles } from "@insite/content-library/Widgets/Common/CartLink";

cartLinkStyles.routerLink = mergeToNew(cartLinkStyles.routerLink, {
    color: "secondary",
});
